module.exports = __webpack_public_path__ + "static/media/avatar-1.0c4030fc.png";